export const loanStatusConstants = [
  { name: "APPLIED", value: "applied" },
  { name: "REJECTED", value: "rejected" },
  { name: "APPROVED", value: "approved" },
  { name: "SENT BACK", value: "sent_back" },
  { name: "RE SUBMIT", value: "re_submit" },
  { name: "FINAL APPLY", value: "final_apply" },
  { name: "CANCEL", value: "cancel" },
];
